import { useState } from 'react';
import { useTranslations } from 'next-intl';

import { ChevronIcon } from '@/component/Icons/ChevronIcon';
import { clearHtml, allClearHtml } from '@/utils/html';
const count = 328;

export const InfoDesc = ({ description }) => {
  const [isVisible, setIsVisible] = useState(false);

  const clearedDescription = allClearHtml(description);
  const text =
    isVisible || clearedDescription.length < count
      ? description
      : `${clearedDescription.slice(0, count)}...`;

  const t = useTranslations();

  return (
    <div className="lg:pr-8 border-t border-slate-300 pt-8 pb-10">
      <p
        className="text-slate-500 text-base leading-normal"
        dangerouslySetInnerHTML={{
          __html: clearHtml(text),
        }}
        data-testid="room-description"
      />

      {description.length >= count && (
        <button
          className="btn btn-second btn-sm mt-6"
          onClick={() => setIsVisible(!isVisible)}
          type="button"
          data-testid="room-description-show-more-button"
        >
          <span>{t(!isVisible ? 'show-more' : 'hide-more')} </span>
          <span className={`${isVisible ? '-rotate-90' : 'rotate-90'} ml-1`}>
            <ChevronIcon />
          </span>
        </button>
      )}
    </div>
  );
};
